module.exports = __webpack_public_path__ + "static/media/CONS.d915ba97.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CONS.jpg
// module id = 1721
// module chunks = 1